import React, { useState, useEffect } from 'react';
import { List, Datagrid, TextField, TextInput, BooleanField, BooleanInput, Filter, Show, SimpleShowLayout, NumberField, ShowButton, ReferenceManyField, RefreshButton, FunctionField } from 'react-admin';
import { Create, SimpleForm, usePermissions } from 'react-admin';
import { cloneElement } from 'react';
import {
    useListContext,
    TopToolbar,
    CreateButton,
    ExportButton,
    EditButton,
    Edit,
    SaveButton,
    Toolbar,
    sanitizeListRestProps,
} from 'react-admin';
// import AddBuildingCostButton from '../buttons/addBuildingCostButton'
import PriceToCostCenterButton from "../buttons/addPriceToCostCenterButton"
import DuplicateCostButtonWithConfirmation from '../buttons/duplicateCostButtonWithConfirmation'

const styles = {
    div1: {
        display: 'block',
        width: "25%",
        float: "left",
        position: "flex",
        marginRight: "10px"
    },
    div1Mobile: {
        display: 'block',
        width: "50%",
        float: "left",
        position: "flex",
        marginLeft: "2%",
        marginRight: "2%"
    },
    div2: {
        display: 'block',
        width: "74%",
        float: "left",
        position: "flex"
    },
    div2Mobile: {
        display: 'block',
        width: "100%",
        float: "left",
        marginLeft: "2%",
        marginRight: "2%",
        marginTop: "2%",
        position: "flex"
    },
    table: {
        overflowX: "auto"
    }
};

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        basePath,
        showFilter,
        total,
    } = useListContext();
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            {permissions.includes("cost_centers.create") &&
                <CreateButton basePath={basePath} label="Crear" />
            }
            {permissions.includes("cost_centers.export") &&
                <ExportButton
                    label="Exportar csv"
                    disabled={total === 0}
                    resource={resource}
                    sort={currentSort}
                    filterValues={filterValues}
                    maxResults={maxResults}
                />
            }
            {/* Add your custom actions */}
        </TopToolbar>
    );
};

const CostCenterTitle = ({ record, optionTitle }) => {
    if (optionTitle) {
        return ""
    }
    return <span>Centro de costo - {record ? `${record.name}` : ''}</span>;
};

export const CostCenterList = props => (
    <List filters={<CostCenterFilter />} {...props} actions={<ListActions />} >
        <Datagrid rowClick="show">
            <ShowButton label="Ver" />
            <TextField source="name" label="Nombre" />
            <TextField source="description" label='Descripción' />
            <BooleanField source="pricePeakHourActivated" label="Precio hora punta activado" />
        </Datagrid>
    </List>
);

const CostCenterShowActions = ({ basePath, data, resource, edit = false, f = false }) => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    if (edit && permissions.includes("cost_centers.edit")) {
        return (
            <TopToolbar>
                {(edit) ? <EditButton basePath={basePath} record={data} label="Editar centro de costo" /> : null}
            </TopToolbar>
        )
    }
    if (f && permissions.includes("prices.list") && permissions.includes("cost_centers.create")) {
        return (
            <TopToolbar>
                <DuplicateCostButtonWithConfirmation basePath={basePath} record={data} label="Duplicar" />
                <RefreshButton label="Recargar precios" />
            </TopToolbar>
        )
    }
    if (f && permissions.includes("prices.list")) {
        return (
            <TopToolbar>
                {permissions.includes("cost_centers.create") && <DuplicateCostButtonWithConfirmation basePath={basePath} record={data} label="Duplicar" />}
                <RefreshButton label="Recargar precios" />
            </TopToolbar>
        )
    }
    if (f && permissions.includes("cost_centers.create")) {
        return (
            <TopToolbar>
                <DuplicateCostButtonWithConfirmation basePath={basePath} record={data} label="Duplicar" />
            </TopToolbar>
        )
    }
    return (<p></p>)
};

function capitalizarPrimeraLetra(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const CostCenterShow = props => {
    const [width, setWindowWidth] = useState(0)

    useEffect(() => {

        updateDimensions();

        window.addEventListener("resize", updateDimensions);
        return () =>
            window.removeEventListener("resize", updateDimensions);
    }, [])
    const updateDimensions = () => {
        const width = window.innerWidth
        setWindowWidth(width)
    }

    const responsive = {
        web: width > 1023
    }

    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }

    return (
        <div>
            <div style={(responsive.web) ? styles.div1 : styles.div1Mobile}>
                <Show title={<CostCenterTitle />} actions={<CostCenterShowActions edit={true} />} {...props}>
                    <SimpleShowLayout >
                        <TextField source="name" label='Nombre' />
                        <TextField source="description" label='Descripción' />
                        <BooleanField source="pricePeakHourActivated" label="Precio diferenciado hora punta" />
                    </SimpleShowLayout>
                </Show>
                <Show title={<CostCenterTitle optionTitle={true} />} actions={<CostCenterShowActions />} {...props}>
                    <SimpleShowLayout>
                        {permissions.includes("buildings.list") &&
                            <ReferenceManyField target="costId" label='Edificios asignados' reference="buildings" link="show">
                                <Datagrid rowClick="show">
                                    <TextField label="Dirección" source="address" link="show" />
                                </Datagrid>
                            </ReferenceManyField>
                        }
                    </SimpleShowLayout>
                </Show>
            </div>
            <div style={(responsive.web) ? styles.div2 : styles.div2Mobile}>
                <Show title={<CostCenterTitle optionTitle={true} />} actions={<CostCenterShowActions f={true} />} {...props}>
                    <SimpleShowLayout>
                        <PriceToCostCenterButton />
                        {permissions.includes("prices.list") &&
                            <ReferenceManyField target="costId" label='Precios asignados' reference="prices" link="show">
                                <Datagrid rowClick="show">
                                    <FunctionField source="machineType" label="Máquina" render={record => {
                                        if (record.machineType) {
                                            return capitalizarPrimeraLetra(record.machineType);
                                        }
                                        return "";
                                    }} />
                                    <TextField source="type" label="Nombre" />
                                    <NumberField source="price" label="Monto" />
                                    <NumberField source="pricePeakHour" label="Monto hora punta" />
                                    <NumberField source="ticks" label="Pulsos" />
                                    <FunctionField source="minutePrice" label="4 minutos" render={record => {
                                        if (record.minutePrice) {
                                            return parseInt(record.minutePrice);
                                        }
                                        return 0;
                                    }} />
                                    <NumberField source="position" label="Posición" />
                                </Datagrid>
                            </ReferenceManyField>
                        }
                    </SimpleShowLayout>
                </Show>
            </div>
        </div>
    )
};

const CostCenterFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="q" alwaysOn />
    </Filter>
);

export const CostCenterCreate = props => (
    <Create {...props}>
        <SimpleForm submitOnEnter={false}>
            <TextInput source="name" label='Nombre' />
            <TextInput source="description" label='Descripción' />
            <BooleanInput source="pricePeakHourActivated" label="Precio diferenciado hora punta"/>
        </SimpleForm>
    </Create>
);

export const CostCenterEdit = props => (
    <Edit {...props}>
        <SimpleForm submitOnEnter={false} toolbar={<CostCenterEditToolbar />}>
            <TextInput source="name" label='Nombre' />
            <TextInput source="description" label='Descripción' />
            <BooleanInput source="pricePeakHourActivated" label="Precio diferenciado hora punta"/>
        </SimpleForm>
    </Edit>
);

const CostCenterEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);
